import { render, staticRenderFns } from "./IconHandOutline.vue?vue&type=template&id=20e99984"
import script from "./IconHandOutline.vue?vue&type=script&lang=js"
export * from "./IconHandOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports